/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetCriticalPointDetailItemDto
 */
export interface GetCriticalPointDetailItemDto {
    /**
     * 
     * @type {string}
     * @memberof GetCriticalPointDetailItemDto
     */
    testName: string;
    /**
     * 
     * @type {string}
     * @memberof GetCriticalPointDetailItemDto
     */
    taskNumber: string;
    /**
     * 
     * @type {string}
     * @memberof GetCriticalPointDetailItemDto
     */
    taskText?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetCriticalPointDetailItemDto
     */
    answerCodeValue?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetCriticalPointDetailItemDto
     */
    answerValue?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetCriticalPointDetailItemDto
     */
    answerValueType?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetCriticalPointDetailItemDto
     */
    criticalType: string;
}

/**
 * Check if a given object implements the GetCriticalPointDetailItemDto interface.
 */
export function instanceOfGetCriticalPointDetailItemDto(value: object): value is GetCriticalPointDetailItemDto {
    if (!('testName' in value) || value['testName'] === undefined) return false;
    if (!('taskNumber' in value) || value['taskNumber'] === undefined) return false;
    if (!('criticalType' in value) || value['criticalType'] === undefined) return false;
    return true;
}

export function GetCriticalPointDetailItemDtoFromJSON(json: any): GetCriticalPointDetailItemDto {
    return GetCriticalPointDetailItemDtoFromJSONTyped(json, false);
}

export function GetCriticalPointDetailItemDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCriticalPointDetailItemDto {
    if (json == null) {
        return json;
    }
    return {
        
        'testName': json['testName'],
        'taskNumber': json['taskNumber'],
        'taskText': json['taskText'] == null ? undefined : json['taskText'],
        'answerCodeValue': json['answerCodeValue'] == null ? undefined : json['answerCodeValue'],
        'answerValue': json['answerValue'] == null ? undefined : json['answerValue'],
        'answerValueType': json['answerValueType'] == null ? undefined : json['answerValueType'],
        'criticalType': json['criticalType'],
    };
}

export function GetCriticalPointDetailItemDtoToJSON(value?: GetCriticalPointDetailItemDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'testName': value['testName'],
        'taskNumber': value['taskNumber'],
        'taskText': value['taskText'],
        'answerCodeValue': value['answerCodeValue'],
        'answerValue': value['answerValue'],
        'answerValueType': value['answerValueType'],
        'criticalType': value['criticalType'],
    };
}

